import { toPng } from 'html-to-image'
import { useEffect, useState } from 'react'
import FullScreenLoader from '../common/components/FullScreenLoader'
import { useSelector } from 'react-redux'
import { chartTypes } from '../common/utils/enum'
import { CORRELATION_NONE_INDICATOR_VALUE } from '../common/utils/constants'

const VisualizationNarrative = ({ chartType }) => {
  const [showContent, setShowContent] = useState(false)
  const [narrative, setNarrative] = useState('')
  const [summary, setSummary] = useState('')
  const [isDataFetching, setIsDataFetching] = useState(false)

  const { isLoading, isSecondIndicatorLoading, selectedSecondIndicator } =
    useSelector((state) => state.indicatorProfile)

  useEffect(() => {
    setShowContent(false)
    setNarrative('')
    setSummary('')
  }, [chartType])

  useEffect(() => {
    if (
      isLoading ||
      isSecondIndicatorLoading ||
      selectedSecondIndicator?.name === CORRELATION_NONE_INDICATOR_VALUE.name
    ) {
      setShowContent(false)
      setNarrative('')
      setSummary('')
    }
  }, [isLoading, isSecondIndicatorLoading, selectedSecondIndicator])

  const getParentElementId = () => {
    let id = ''
    switch (chartType) {
      case chartTypes.Map:
        id = 'worldmap_container'
        break
      case chartTypes.Trend:
        id = 'lineChart_container'
        break
      case chartTypes.Bar:
        id = 'bar_chart_container'
        break
      case chartTypes.Correlation:
        if (
          selectedSecondIndicator?.name ===
          CORRELATION_NONE_INDICATOR_VALUE.name
        ) {
          id = 'beeswarm_container'
        } else {
          id = 'scatter_chart_container'
        }
        break
      case chartTypes.DataTable:
        id = 'datatable_container'
        break
      default:
        id = 'worldmap_container'
    }
    return id
  }

  const excludeElements = () => {
    const id = getParentElementId(),
      node = document.getElementById(id)
    let exclusionClasses = ['download-exclude']
    if (
      chartType === chartTypes.Correlation &&
      selectedSecondIndicator?.name !== CORRELATION_NONE_INDICATOR_VALUE.name
    ) {
      exclusionClasses = ['highcharts-exporting-group']
    }
    return !exclusionClasses.some((classname) =>
      node.classList?.contains(classname)
    )
  }

  const showNarrative = () => {
    setIsDataFetching(true)

    const id = getParentElementId(),
      fileName = 'data360_visualization.png'
    if (chartType === chartTypes.DataTable) {
      let scrollableTable = document.querySelector(
        `#${id} #data-table-section:last-child>table`
      )
      scrollableTable.style.height = 'unset'
      scrollableTable.style.overflowY = 'visible'
    } else if (chartType === chartTypes.Bar) {
      let scrollableChart = document.querySelector(
        `#${id} .highcharts-scrolling`
      )
      if (scrollableChart) {
        scrollableChart.style.height = 'unset'
        scrollableChart.style.overflow = 'visible'
      }
    }
    const node = document.getElementById(id)
    toPng(node, { filter: excludeElements, backgroundColor: '#ffffff' })
      .then((dataurl) => {
        var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]),
          n = bstr.length,
          u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const file = new File([u8arr], fileName, { type: mime })
        let form = new FormData()
        form.append('file', file)
        form.append(
          'prompt',
          'Generate a concise and insightful narrative for the following attached data visualization image . Focus on key trends, correlations (or lack thereof), and significant outliers.'
        )
        form.append(
          'prompt2',
          'Provide a one-paragraph summary of the following narrative, capturing its main theme and essential details:'
        )
        var settings = {
          url: 'https://aemauthorstg65.worldbank.org/wbg/aem/service/vertexai/dataviznarrative',
          form: form,
        }

        fetchNarrative(settings)
        if (chartType === chartTypes.DataTable) {
          let scrollableTable = document.querySelector(
            `#${id} #data-table-section:last-child>table`
          )
          scrollableTable.style.height = '550px'
          scrollableTable.style.overflowY = 'auto'
        } else if (chartType === chartTypes.Bar) {
          let scrollableChart = document.querySelector(
            `#${id} .highcharts-scrolling`
          )
          if (scrollableChart) {
            scrollableChart.style.height = '700px'
            scrollableChart.style.overflow = 'hidden auto'
          }
        }
      })
      .catch((err) => {
        console.log(err)
      })
    setShowContent(!showContent)
  }

  const fetchNarrative = async (settings) => {
    try {
      const response = await fetch(settings.url, {
        body: settings.form,
        method: 'POST',
        mimeType: 'multipart/form-data',
        contentType: false,
        processData: false,
        timeout: 0,
      })
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`)
      }

      const json = await response.json()
      setNarrative(json.narrative)
      setSummary(json.summary)
    } catch (error) {
      setNarrative('Failed to fetch narrative')
      console.error('failed to fetch narrative', error.message)
    } finally {
      setIsDataFetching(false)
    }
  }
  return (
    <>
      {isLoading || isSecondIndicatorLoading ? (
        ''
      ) : (
        <div className="full-row-white-box" style={{ paddingBottom: '0' }}>
          {isDataFetching && <FullScreenLoader />}

          <div
            className="cmp-accordion__item"
            data-cmp-hook-accordion="item"
            data-cmp-data-layer='{"accordion-36e173495f-item-baa095d529":{"@type":"datatopics/components/accordion/item","repo:modifyDate":"2024-02-21T19:37:42Z","dc:title":"What is Prosperity Data360?"}}'
            id="accordion-narative"
            data-cmp-expanded=""
          >
            <h3 className="cmp-accordion__header">
              <button
                id="accordion-narative-button"
                className="cmp-accordion__button cmp-accordion__button--expanded"
                type="button"
                // aria-controls="accordion-narative-panel"
                data-cmp-hook-accordion="button"
                aria-expanded={showContent ? 'true' : 'false'}
                onClick={() => {
                  if (showContent) {
                    setShowContent(false)
                  } else {
                    showNarrative()
                  }
                }}
              >
                <span className="cmp-accordion__title">
                  Visualization narrative
                </span>
                <span className="cmp-accordion__icon"></span>
              </button>
            </h3>
            {showContent && (
              <div
                data-cmp-hook-accordion="panel"
                id="accordion-narative-panel"
                className="cmp-accordion__panel cmp-accordion__panel--expanded"
                role="region"
                aria-labelledby="accordion-narative-button"
                //   aria-hidden="false"
              >
                <div className="text">
                  {narrative && (
                    <div id="narrative-text" className="cmp-text">
                      <p>
                        <strong>Narrative: </strong>
                        {narrative}
                      </p>
                    </div>
                  )}
                  <br />
                  {summary && (
                    <div id="summary-text" className="cmp-text">
                      <p>
                        <strong>Summary: </strong>
                        {summary}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default VisualizationNarrative
